import React from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";

export default function CustomQbHome(){
    return(
        <div className="main_wrapper">
            <div className="breadcrumbs">
                <ul className="breadcrumb">
                    <li className="breadcrumb-item"><a>Home</a></li>
                    <li className="breadcrumb-item"><a>QBank</a></li>
                    <li className="breadcrumb-item active"><a>Custom QBank</a></li>
                </ul>
            </div>
            <section className="videoLayer_wrapper account_main_wrapper account_setting_wrapper qbanks_home_wrapper section_side_padding">
                <div className='row'>
                    <div className="col-lg-8 col-md-7 col-sm-12">
                        <div className="subjects_wrapper">
                            <div className="setting_ttl_wrapper d-flex align-items-center">
                                <figure className="sett_back_arrow">
                                {/* <Link to={'/account'}> */}
                                    <img src={Icons.BackArrow} alt="" className="img-fluid"/>
                                {/* </Link> */}
                                </figure>
                                <div className="sett_ttl">
                                    <h5>Custom QBank</h5>
                                </div>
                            </div>
                        </div>
                        <div className="subjects_wrapper">
                            <div className="shared_qbanks_wrapper">
                                <div className="shared_qb_header">
                                    <h5>Shared QBank</h5>
                                    <p>If you have Qbank code that has been shared with you please write here to take Qbank or create a new one</p>
                                </div>
                                <div className="qbank_code_field d-flex align-items-center">
                                    <div className="code_field">
                                        <input type="text" name="" className="form-control" placeholder="Enter Qbank Code"/>
                                    </div>
                                    <div className="submit_btn">
                                        <button type="button" className="btn_code_submit">Submit <img src={Icons.ArrowBlue} alt="" className="img-fluid"/></button>
                                    </div>
                                </div>
                            </div>
                            <div className="separator">
                                <span>Or</span>
                            </div>
                            <div className="createQbBtn">
                                <button type="button" className="btn btn_create"><img src={Icons.Plus_Circle} alt="" className="img-fluid"/> Create Custom Qbank</button>
                            </div>
                            <div className="create_text_tagline d-flex align-items-center">
                                <div className="tagline_text_header d-flex align-items-center">
                                    <figure>
                                        <img src={Icons.Info} alt="" className="img-fluid"/>
                                    </figure>
                                    <div className="tag_txt">
                                        <p>You have created <span>2 out of 5</span> QBanks. Buy our QBank Package for creating as many.</p>
                                    </div>
                                </div>
                                <div className="tag_arrow">
                                    <img src={Icons.ArrowBlue} alt="" className="img-fluid"/>
                                </div>
                            </div>
                            <div className="blankQb_wrapper text-center">
                                <img src={Images.Blank_Qb} alt="" className="img-fluid"/>
                                <h4>No Custom QBank Created</h4>
                                <p>You don’t have any custom Qbank created please create a new one to get started</p>
                            </div>
                            <div className="custom_note">
                                <h6><span>Note:</span> You can only create one Custom Qbank at the same time. If you want to create a new one delete previous Qbank </h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12">
                        {/* <div className="videos_wrapper">
                            <div className="buy_packages d-flex align-items-center">
                                <div className="package_text">
                                    <h6>Buy Package</h6>
                                    <p>Buy Package to unlock content and Start Learning</p>
                                </div>
                                <div className="package_img">
                                    <img src={Images.Package} alt="" className="img-fluid"/>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </section>
        </div>
    )
}